import { render, staticRenderFns } from "./duvidas-frequentes.vue?vue&type=template&id=3c431efe"
import script from "./duvidas-frequentes.vue?vue&type=script&lang=js"
export * from "./duvidas-frequentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports